// Copyright (c) 2023 Jürgen Gebath
//
// This software is released under the MIT License.
// https://opensource.org/licenses/MIT

export const lightTheme = {
  palette: {
    mode: "light",
    primary: {
      main: "#d63b37",
    },
    secondary: {
      main: "#cb952b",
    },
    error: {
      main: "#d32f2f",
    },
    brand: {
      main: "#313232",
    },
    text: {
      brand: "white",
    },
  },
  components: {
    MuiAppBar: {
      defaultProps: {
        color: "brand",
      },
    },
  },
};

export const darkTheme = {
  palette: {
    mode: "dark",
    primary: {
      main: "#d63b37",
    },
    secondary: {
      main: "#cb952b",
    },
    error: {
      main: "#d32f2f",
    },
    brand: {
      main: "#313232",
    },
    text: {
      brand: "white",
    },
  },
  components: {
    MuiAppBar: {
      defaultProps: {
        color: "brand",
      },
    },
  },
};
